<div class="widget widget_categories">
    <h2 class="widget-title">Categories</h2>
    <ul>
        <li *ngFor="let list of List" class="cat-item"><a href="javascript:void(0)">{{ list.title }}</a></li>
    </ul>
</div>